export default "__VITE_ASSET__CPvz_vn6__"